import { render, staticRenderFns } from "./upcomingTrainingsComp.vue?vue&type=template&id=580e3680"
import script from "./upcomingTrainingsComp.vue?vue&type=script&lang=js"
export * from "./upcomingTrainingsComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports